<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3 class="headlink">
      Music
    </h3>
    <p class="text-center">music projects i've worked on.</p>

    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/oliverdecrow.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Oliver Decrow</strong><br />
              Current soloproject (Synth, Minimal Wave, Cold Wave), with
              releases on the french record label
              <a
                href="https://www.residentadvisor.net/record-label.aspx?id=1938"
                target="new"
                ><u>I'm a Cliché Records</u></a
              >. <br /><br />
              <a href="https://soundcloud.com/oliver-decrow" target="new"
                ><i class="fa fa-soundcloud"></i>
                soundcloud.com/oliver-decrow<br
              /></a>
              <a href="http://oliverdecrow.com" target="new"
                ><i class="fa fa-external-link"></i> www.oliverdecrow.com</a
              >
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/frichundorn.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Frich & Orn</strong><br />
              Electronic music project with Thomas Fröhlich, 2014-2016<br /><br />
              <a href="https://soundcloud.com/frichorn" target="new"
                ><i class="fa fa-soundcloud"></i> soundcloud.com/frichorn<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/bossariobang.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Bossa Rio Bang</strong><br />
              Electronic Bossa Nova music project with Annette Jahns and Ludwig
              Jahns premiered on Radio Fritz Berlin.<br /><br />
              <a href="https://soundcloud.com/bossariobang" target="new"
                ><i class="fa fa-soundcloud"></i>
                soundcloud.com/bossariobang<br
              /></a>
              <a
                href="https://soundcloud.com/bossariobang/radio-fritz-caro-korneli-bossa-rio-bang-23122014"
                target="new"
              >
                <i class="fa fa-microphone"></i> Live record hosted by Caro
                Kornelli</a
              >
            </p>
          </div>
        </div>
      </div>
      <!-- end row 1 -->
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/bornkissed.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Bornkissed</strong><br />
              Electronic music project with Kiki still in production
              <br /><br />
              <a href="https://soundcloud.com/bornkissed" target="new"
                ><i class="fa fa-soundcloud"></i> soundcloud.com/bornkissed<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/vision30.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Vision 30</strong><br />
              Music project (Postpunk, Synth, EBM) with TopNotch, Fan83 (WhyNot)
              & Anne (Kairo, Pisse), released on ltd. dubplate vinyl<br /><br />
              <a href="https://soundcloud.com/vision30" target="new"
                ><i class="fa fa-soundcloud"></i> soundcloud.com/vision30<br
              /></a>
              <a href="https://www.youtube.com/watch?v=kWWrqMqKp6c" target="new"
                ><i class="fa fa-youtube"></i> Musicvideo on youtube<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/kreuzchen.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Kreuzchen</strong><br />
              EBM music project. Single released on ltd. dubplate vinyl with
              vocals by Marcus M. Schoeneich and Kiki.<br /><br />
              <a
                href="https://soundcloud.com/g23brecords/kreuzchen-exhibition-voyeur"
                target="new"
                ><i class="fa fa-soundcloud"></i> Kreuzchen - Exhibition
                Voyeur<br
              /></a>
            </p>
          </div>
        </div>
      </div>
      <!-- end row 2 -->
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/casini80.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Casini 80</strong><br />
              Music project (Electronic, Minimal Wave, NDW, 80ies)
              <br /><br />
              <a href="https://soundcloud.com/casini80" target="new"
                ><i class="fa fa-soundcloud"></i> soundcloud.com/casini80<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/coltcody.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Colt Cody</strong><br />
              Solo music project (EBM, Trap, Hip-Hop)<br /><br />
              <a href="https://soundcloud.com/colt-cody-beatz" target="new"
                ><i class="fa fa-soundcloud"></i>
                soundcloud.com/colt-cody-beatz<br
              /></a>
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/elliolli.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Elli.Olli</strong><br />
              Electronic music project with several musicvideos produced in
              Montreal (CA) and New York (USA)<br /><br />
              <a
                href="https://www.youtube.com/playlist?list=PL31AFE2E542F5340D"
                target="new"
                ><i class="fa fa-youtube"></i> Musicvideo playlist<br
              /></a>
            </p>
          </div>
        </div>
      </div>
      <!-- end row 3 -->
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            class="card-img-top rounded-0 "
            src="@/assets/images/music/diegestalt.png"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-left">
              <strong>Die Gestalt</strong><br />
              NDW solo music project.
              <br /><br />
              <a href="https://soundcloud.com/diegestalt80" target="new"
                ><i class="fa fa-soundcloud"></i>
                soundcloud.com/diegestalt80<br
              /></a>
            </p>
          </div>
        </div>
      </div>
      <!-- end row 4 -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
